const translations = {
  'about': 'About Axioma Flexi',
  'appName': 'Flexi',
  'data': 'Data',
  'tasks': 'Tasks',
  'logout': 'Sign out',
  'password': 'Password',
  'email': 'Email',
  'login': 'Sign in',
  'loginError': 'Email or password incorrect.',
  'pleaseWait': 'Please wait...',
  'loggedOut': 'Signed out.',
  'monday': 'Monday',
  'tuesday': 'Tuesday',
  'wednesday': 'Wednesday',
  'thursday': 'Thursday',
  'friday': 'Friday',
  'saturday': 'Saturday',
  'sunday': 'Sunday',
  'header': 'Task',
  'type': 'Type',
  'typeActivity': 'Activity',
  'typeBoard': 'Personnel/Management',
  'typeDevelopment': 'Strategic development',
  'task': 'Task',
  'plannedResult': 'Goal',
  'achievedResult': 'Result',
  'rating': 'Evaluation',
  'ratingMet': 'Satisfying',
  'ratingNotMet': 'Unsatisfying',
  'ratingAverage': 'Average',
  'save': 'Save',
  'datePicker': 'Select date...',
  'cancel': 'Cancel',
  'ok': 'Select',
  'date': 'Date',
  'weekday0': 'Monday',
  'weekday1': 'Tuesday',
  'weekday2': 'Wednesday',
  'weekday3': 'Thursday',
  'weekday4': 'Friday',
  'weekday5': 'Saturday',
  'weekday6': 'Sunday',
  'week': 'Week',
  'user': 'User',
  'findDriver': 'Search drivers...',
  'noResults': 'No results',
  'comments': 'Comments',
  'help': 'Help',
  'delete': 'Remove',
  'confirmTaskDelete': 'Are you sure you want to remove the task?',
  'myTasks': 'My tasks',
  'sessionExpired': 'Session expired. Please sign in.',
  'attachFile': 'Attach file',
  'confirmCommentDelete': 'Are you sure you want to remove the file?',
  'commentEmail': 'Commented by email.',
  'required': 'Required field',
  'no.data.found': 'No results found.',
  'system.error.message':
    'Error occured. Please send screenshot to ' +
    '<a href="mailto:support@axs.eu">support@axs.eu<a>',
  'system.backend.error.message':
    'Data error occured. Ekrano vaizdą prašome siųsti ' +
    'el.paštu <a href="mailto:support@axs.eu">support@axs.eu<a>',
  'network.error.message': 'A network error has occured. Please, try again',
  'db.duplicate.error': 'Record duplicates',
  'empty.message': ' ',
  'create.new': 'Create new',
  'comment.add': 'Add comment',
  'comment.show': 'View comments',
  'changeLog.title': 'Change log',

  'two.factor.authentication': "Two Factor Authentication",
  'enter.verification.code': "Enter Verification Code",
  'confirmation.code': "Verification Code",
  'remember.this.device': "Trust this device for 14 days",
  'sending': "Sending",
  'resend': "Resend",
  'submit': "Submit",
  'verify': "Verify",
  'invalid.verification.code': "Invalid verification code",
  'verification.code.sent': "Verification code sent",
  'twoFA.Request.Failed:': "Verification code failed to send",

  'selectField.no.options': 'No options found',
  'event.title': 'Parameters',
  'event.indicatorName.filter': 'Parameter',
  'event.indicatorCode.filter': ' Parameter code',
  'event.eventDateTime.date': 'Event date',
  'event.eventDateTime.time': 'Event time',
  'event.valueFilter.filter': 'Value',

  'units.title': 'Units',
  'unit.title': 'Unit',
  'unit.create.tooltip': 'Create unit',
  'unit.updated': 'Unit updated',
  'unit.created': 'Unit created',
  'unit.removed': 'Unit removed',
  'unit.remove.error':
    'Unit cannot be removed because of relations with other data.',
  'unit.filter': 'Search for units...',
  'unit.modify.title': 'Edit unit',
  'unit.create.title': 'Create unit',
  'unit.delete.confirm': 'Are you sure you want to remove unit?',
  'unit.name': 'Title',
  'unit.abbreviation': 'Abbreviation',
  'unit.type': 'Type',
  'unit.type.STRING': 'Text',
  'unit.type.BOOLEAN': 'Yes/No',
  'unit.type.INTEGER': 'Number',
  'unit.type.FLOAT': 'Decimal number',
  'unit.type.DATE': 'Date',

  'objects.title': 'Objects',
  'object.title': 'Object',
  'object.create.tooltip': 'Create object',
  'object.updated': 'Object updated',
  'object.created': 'Object created',
  'object.removed': 'Object removed',
  'object.remove.error':
  'Object cannot be removed because of relations with other data.',
  'object.filter': 'Search for objects...',
  'object.modify.title': 'Edit object',
  'object.create.title': 'Create object',
  'object.delete.confirm': 'Are you sure you want to remove object?',
  'object.name': 'Title',
  'object.code': 'Code',
  'object.abbreviation': 'Abbreviation',
  'object.description': 'Description',
  'object.search': 'Search for objects...',

  "object.report.companyName": "Company nae",
  "object.report.address": "Address",
  "object.report.city": "City",
  "object.report.website": "Website",
  "object.report.phone": "Phone number",
  "object.report.email": "Email",
  "object.report.companyCode": "Company code",
  "object.report.vatCode": "VAT code",
  "object.report.bankDetails": "Bank details",
  "object.report.workAcceptedBy": "Work accepted by",
  "object.report.primaryColor": "Primary color",
  "object.report.postalCode": "Postal code",
  "object.report.country": "Country",

  'areas.title': 'Areas',
  'area.title': 'Area',
  'area.create.tooltip': 'Create area',
  'area.updated': 'Area updated',
  'area.created': 'Area created',
  'area.removed': 'Area removed',
  'area.remove.error':
    'Area cannot be removed because of relations with other data.',
  'area.filter': 'Search for areas...',
  'area.modify.title': 'Edit area',
  'area.create.title': 'Create area',
  'area.delete.confirm': 'Are you sure you want to remove area?',
  'area.name': 'Title',
  'area.description': 'Description',

  'equipments.title': 'Devices',
  'equipment.title': 'Device',
  'equipment.create.tooltip': 'Create device',
  'equipment.updated': 'Device updated',
  'equipment.created': 'Device created',
  'equipment.removed': 'Device removed',
  'equipment.remove.error':
    'Device cannot be removed because of relations with other data.',
  'equipment.filter': 'Search for devices...',
  'equipment.modify.title': 'Edit device',
  'equipment.create.title': 'Create device',
  'equipment.delete.confirm': 'Are you sure you want to remove the device?',
  'equipment.object': 'Object',
  'equipment.area': 'Area',
  'equipment.name': 'Title',
  'equipment.code': 'Code',
  "equipment.externalCode": "External code",
  'equipment.description': 'Description',
  'equipment.export.success': 'Export successfully done',
  'equipment.export.failed': 'Equipment export failed',
  'equipment.export.unauthorized' : 'User is not authorized',

  'reports.title': 'Tables',
  'report.modify.title': 'Edit table',
  'report.create.title': 'Create table',
  'report.name': 'Title',
  'report.object': 'Object',
  'report.indicators.select': 'Parameters',
  'report.indicator.add': 'Add',
  'report.added.indicators': 'Added parameters',
  'report.indicator.aggregation.type.select': 'Aggregation type',
  'report.indicator.aggregation.type.AVG': 'Average',
  'report.indicator.aggregation.type.MIN': 'Minimum',
  'report.indicator.aggregation.type.MAX': 'Maximum',
  'report.indicator.aggregation.type.short.AVG': 'avg.',
  'report.indicator.aggregation.type.short.MIN': 'min.',
  'report.indicator.aggregation.type.short.MAX': 'max.',
  'report.indicator.search': 'Parameter',
  'report.created': 'Table created',
  'report.updated': 'Table updated',
  'report.create.tooltip': 'Create table',
  'report.search': 'Table',
  'report.modify': 'Edit',
  'report.remove': 'Remove',
  'report.remove.confirm': 'Are you sure you want to remove table?',
  'report.remove.error':
    'Table cannot be removed because of relations with other data ' +
    ' (etc Dashboard).',
  'report.removed': 'Table removed',
  'report.indicators.validation.error': 'No parameters added',
  'report.export.pdf': 'Pdf',
  'report.export.excel': 'Excel',
  'report.export.excel.error': 'Error while creating an excel file',
  'report.default.name': ' Table',
  'report.results.chart': 'Display results on graph',
  'report.results.table': 'Display the results in the table',
  'report.upsert.error': 'Table could not be saved',
  'reports.journalsRowNo.button': 'change journal numeration',
  'report.slowLoad':
    'Data generation will take longer, because of large amount of data...',

  'graphs.title': 'Graphs',
  'graph.modify.title': 'Edit graph',
  'graph.create.title': 'Create graph',
  'graph.name': 'Title',
  'graph.object': 'Object',
  'graph.indicators.select': 'Parameters',
  'graph.indicator.add': 'Add',
  'graph.added.indicators': 'Added parameters',
  'graph.indicator.aggregation.type.select': 'Aggregation type',
  'graph.indicator.aggregation.type.AVG': 'Average',
  'graph.indicator.aggregation.type.MIN': 'Minimum',
  'graph.indicator.aggregation.type.MAX': 'Maximum',
  'repgraphort.indicator.aggregation.type.short.AVG': 'avg.',
  'graph.indicator.aggregation.type.short.MIN': 'min.',
  'graph.indicator.aggregation.type.short.MAX': 'max.',
  'graph.indicator.search': 'Parameter',
  'graph.created': 'Graph created',
  'graph.updated': 'Graph updated',
  'graph.create.tooltip': 'Create graph',
  'graph.search': 'Graph',
  'graph.modify': 'Edit',
  'graph.remove': 'Remove',
  'graph.remove.confirm': 'Are you sure you want to remove graph?',
  'graph.remove.error':
    'Graph cannot be removed because of relations with other data ' +
    ' (etc Dashboard).',
  'graph.removed': 'Graph removed',
  'graph.indicators.validation.error': 'No parameters added',
  'graph.default.name': ' Graph',
  'graph.upsert.error': 'Graph could not be saved',
  'graphs.journalsRowNo.button': 'change journal numeration',
  'graph.slowLoad':
    'Data generation will take longer, because of large amount of data...',
  'graphs.generate': 'Generate',

  'journal.rowno.error': 'This journal does not have starting numeration',
  'journal.create.title': 'Journal numeration change',
  'journal.startingRowNo': 'New line number',
  'journal.fromDate': 'Start date',
  'journalType.select': 'Choose journal',
  'journal.created': 'Journal numeration changed',
  'systemType.select': 'Choose system',
  'systemType.DIESEL': 'Diesel',
  'systemType.GAS': 'Gas',

  'indicators.title': 'Parameters',
  'indicator.title': 'Parameter',
  'indicator.create.tooltip': 'Create parameter',
  'indicator.updated': 'Parameter updated',
  'indicator.created': 'Parameter created',
  'indicator.removed': 'Parameter removed',
  'indicator.remove.error':
    'Parameter cannot be removed because of relations with other data.',
  'indicator.filter': 'Search for parameters...',
  'indicator.modify.title': 'Edit parameter',
  'indicator.create.title': 'Create parameter',
  'indicator.delete.confirm': 'Are you sure you want to remove parameter?',
  'indicator.equipment': 'Device',
  'indicator.unit': 'Unit',
  'indicator.name': 'Title',
  'indicator.code': 'Code',
  'indicator.description': 'Parameter description',
  'indicator.minLimit': 'Limit from',
  'indicator.maxLimit': 'Limit to',
  'indicator.type': 'Type',
  'indicator.type.S': 'Simple',
  'indicator.type.C': 'Composite',
  'compositeIndicator.title': 'Composite parameters',
  'compositeIndicator.add': 'Add',
  'compositeIndicator.remove': 'Remove',
  'compositeIndicator.empty': 'Choose composite parameters',
  'compositeIndicator.duplicate': 'Composite parameters duplicates',

  'unknownIndicators.title': 'Unknown parameters',
  'unknownIndicators.last.value': 'Last value',

  'journalNames.title': 'Journals',
  'journalName.title': 'Journal',
  'journalName.nonUser': 'Prohibited for Operators',
  'journalName.create.tooltip': 'Create journal',
  'journalName.updated': 'Journal updated',
  'journalName.created': 'Journal created',
  'journalName.removed': 'Journal removed',
  'journalName.remove.error':
    'Journal cannot be removed because of relations with other data.',
  'journalName.filter': 'Search for journals...',
  'journalName.modify.title': 'Edit journal',
  'journalName.create.title': 'Create journal',
  'journalName.delete.confirm': 'Are you sure you want to remove journal?',
  'journalName.name': 'Template title',
  'journalName.object': 'Object',
  'journalName.type': 'Type',
  'journalName.type.BASIC': 'Basic journal',
  'journalName.type.ISSUE': 'Journal with states',
  'journalName.journalName': 'Title',
  'journalName.template': 'Template',
  'journalName.clear.journalTemplate': 'Remove template',
  "journalName.repair.issueType.invalid": "Repair journal must have exactly one issue type",
  "journalName.purpose": "Journal purpose",
  "journalName.purpose.STANDARD": "Standard",
  "journalName.purpose.REPAIR": "Repair",
  "journalName.repair.type.invalid": "Repair journal has to be journal with states",
  "journalName.repair.object.required": "Repair journal has to be assigned to an object",
  "journalName.repair.duplicate": "This object already has a repair journal",

  'journalTemplates.title': 'Journal templates',
  'journalTemplate.Field.title': 'Templates',
  'journalTemplate.title': 'Template',
  'journalTemplate.create.tooltip': 'Create template',
  'journalTemplate.updated': 'Template updated',
  'journalTemplate.created': 'Templated created',
  'journalTemplate.removed': 'Template removed',
  'journalTemplate.filter': 'Search for templates...',
  'journalTemplate.modify.title': 'Edit template',
  'journalTemplate.create.title': 'Create template',
  'journalTemplate.delete.confirm':
    'Are you sure you want to remove the template?',
  'journalTemplate.name': 'Title',
  'journalTemplate.journalName': 'Title',
  'journalTemplate.template': 'Template text',

  'journalRecords.title': 'Journals',
  'journalRecord.title': 'Journal',
  'journalRecord.create.tooltip': 'Create event',
  'journalRecord.updated': 'Journal updated',
  'journalRecord.created': 'Journal created',
  'journalRecord.removed': 'Journal removed',
  'journalRecord.upsert.error': 'Journal could not be saved',
  'journalRecord.remove.error':
    'Journal cannot be removed because of relations with other data.',
  'journalRecord.filter': 'Search for journals...',
  'journalRecord.modify.title': 'Edit journal',
  'journalRecord.create.title': 'Create event',
  'journalRecord.delete.confirm':
    'Are you sure you want to remove the journal?',
  'journalRecord.date': 'Time',
  'journalRecord.date.date': 'Date',
  'journalRecord.date.time': 'Time',
  'journalRecord.date.from': 'Date from',
  'journalRecord.date.to': 'Date to',
  'journalRecord.content': 'Content',
  'journalRecord.content.filter': 'Content',
  'journalRecord.journalName': 'Title',
  'journalRecord.template': 'Template',
  'journalRecord.user': 'User',
  'journalRecord.createdAt': 'Creation Date',

  'journalRecord.files.title': 'Files',
  'journalRecord.file.remove': 'Remove',

  'journalComments.title': 'Comments',
  'journalComment.title': 'Comment',
  'journalComment.create.tooltip': 'Create comment',
  'journalComment.updated': 'Comment updated',
  'journalComment.created': 'Comment created',
  'journalComment.removed': 'Comment removed',
  'journalComment.filter': 'Search for comments...',
  'journalComment.modify.title': 'Edit comment',
  'journalComment.create.title': 'Create comment',
  'journalComment.delete.confirm':
    'Are you sure you want to remove the comment?',
  'journalComment.date': 'Time',
  'journalComment.date.date': 'Date',
  'journalComment.date.time': 'Time',
  'journalComment.comment': 'Comment',

  'issues.title': 'Events',
  'issue.title': 'Event',
  'issue.create.tooltip': 'Create event',
  'issue.updated': 'Event updated',
  'issue.created': 'Event created',
  'issue.removed': 'Event removed',
  'issue.upsert.error': 'Event could no be saved',
  'issue.remove.error':
    'Event cannot be removed because of relations with other data.',
  'issue.filter': 'Search for events...',
  'issue.modify.title': 'Edit event',
  'issue.create.title': 'Create event',
  'issue.delete.confirm': 'Are you sure you want to remove the event?',
  'issue.date': 'Time',
  'issue.date.date': 'Date',
  'issue.date.time': 'Time',
  'issue.date.from': 'Date from',
  'issue.date.to': 'Date to',
  'issue.name': 'Title',
  'issue.content': 'Content',
  'issue.user': 'Creator',
  'issue.responsible': 'Responsible',
  'issue.content.filter': 'Event content',
  'issue.journalName': 'Event title',
  'issue.area.name': 'Area',
  'issues.content': 'Content',
  'issues.equipment.name': 'Equipment',
  'issue.equipment.name': 'Equipment',
  'issue.user.name': 'User name',
  'issue.user.surname': 'User surname',
  'issue.responsible.name': 'Responsible name',
  'issue.responsible.surname': 'Responsible surname',
  'issue.issueState.name': 'State',
  'issue.issueType.name': 'Type',
  'issue.issueFiles.fileName': 'File name',
  'issue.issueTasks.task': 'Task',
  'issue.issueTasks.responsible': 'Asignee',
  'issue.issueTasks.issueState': 'Implementation state',
  'issue.issueTasks.issueState.name': 'Implementation state',
  'issue.area': 'Area',
  'issue.equipment': 'Equipment',
  'issue.exportPdf': 'Download PDF',

  'issueFiles.title': 'Files',
  'issueFile.delete.confirm': 'Are you sure you want to remove the file?',
  'issueFile.removed': 'File removed',
  'issueFile.created': 'File added',

  'issueTasks.title': 'Asignees',
  'issueTask.delete.confirm': 'Are you sure you want to remove the Asignee',
  'issueTask.removed': 'Asignee removed',
  'issueTask.created': 'Asignee added',
  'issueTask.task': 'Task',
  'issueTask.issueState.updated': 'Task state changed',
  'issueTask.responsible': 'Asignee',

  'issueItems.title': 'Used warehouse goods',
  'issueItem.delete.confirm':
    'Are you sure you want to remove the warehouse good?',
  'issueItem.amount': 'Amount',
  'issueItem.replenished': 'Warehouse good removed',
  'issueItem.reduced': 'Warehouse good added',
  'issueItem.date': 'Date',

  'issueComments.title': 'Comments',
  'issueComment.title': 'Comment',
  'issueComment.create.tooltip': 'Create comment',
  'issueComment.updated': 'Comment updated',
  'issueComment.created': 'Comment created',
  'issueComment.removed': 'Comment removed',
  'issueComment.filter': 'Search for comments...',
  'issueComment.modify.title': 'Edit comment',
  'issueComment.create.title': 'Create comment',
  'issueComment.delete.confirm': 'Are you sure you want to remove the comment?',
  'issueComment.date': 'Time',
  'issueComment.date.date': 'Date',
  'issueComment.date.time': 'Time',
  'issueComment.comment': 'Comment',

  'issueTypes.title': 'Event types',
  'issueType.title': 'Event type',
  'issueType.create.tooltip': 'Create event type',
  'issueType.updated': 'Event type updated',
  'issueType.created': 'Event type created',
  'issueType.removed': 'Event type removed',
  'issueType.remove.error':
    'Event type cannot be removed because of relations with other data.',
  'issueType.filter': 'Search for event types...',
  'issueType.modify.title': 'Edit event type',
  'issueType.create.title': 'Create event type',
  'issueType.delete.confirm': 'Are you sure you want to remove the event type?',
  'issueType.name': 'Title',
  'issueType.issueStates.removed': 'Event state removed',
  'issueType.issueStates.added': 'Event state added',

  'issueStates.title': 'Event states',
  'issueState.title': 'Event state',
  'issueState.create.tooltip': 'Create event state',
  'issueState.updated': 'Event state updated',
  'issueState.created': 'Event state created',
  'issueState.removed': 'Event state removed',
  'issueState.remove.error':
    'Event state cannot be removed because of relations with other data.',
  'issueState.filter': 'Search for event states...',
  'issueState.modify.title': 'Edit event state',
  'issueState.create.title': 'Create event state',
  'issueState.delete.confirm':
    'Are you sure you want to remove the event state?',
  'issueState.name': 'Title',
  'issueState.issueTypes.removed': 'Event type removed',
  'issueState.issueTypes.added': 'Event type added',
  'issueState.color': 'Color',
  'issueState.color.#e57373': 'Red',
  'issueState.color.#64b5f6': 'Blue',
  'issueState.color.#81c784': 'Green',
  'issueState.color.#dce775': 'Yellow',
  'issueState.color.#ff8a65': 'Orange',
  'issueState.color.#a1887f': 'Brown',
  'issueState.color.#e0e0e0': 'Grey',

  'issueTypeState.issueType.filter': 'Event type',
  'issueTypeState.issueState.filter': 'Event state',

  'issueWorkAct.title': 'Work act information',
  'issueWorkAct.workBy': 'Work done by',
  'issueWorkAct.description': 'Description of work',
  'issueWorkAct.equipmentWork': 'Equipment work hours',
  'issueWorkAct.updated': 'Work act information updated',

  // material form generic
  'materials': 'Products',
  'materials.title': 'Products',
  'material.title': 'Product',
  'material.delete.confirm': 'Are you sure you want to remove product?',
  'material.updated': 'Product updated',
  'material.removed': 'Product removed',
  'material.created': 'Product created',
  'material.filter': 'Search for product...',
  'material.select': 'Product',
  'material.modify.title': 'Product',
  'material.create.title': 'Create product',
  'material.create.tooltip': 'Create product',
  // material form specific
  'material.type': 'product',
  'material.description': 'Description',
  'material.shortDescription': 'Short description',
  'material.classificator': 'Classificator',
  'material.tarrifGroupCode': 'Tarrif group code',
  'material.materialType': 'Product type',
  'material.name.unique': 'Product title should be unique.',
  'refresh.page': 'Refresh',
  'version.mismatch': 'System version update',
  'click.refresh.button':
    'System version updated. ' +
    'Click "Refresh" in order to use up to date version.',

  // driver form generic
  'drivers': 'Drivers',
  'drivers.title': 'Drivers',
  'driver.title': 'Driver',
  'driver.create.tooltip': 'Create driver',
  'driver.updated': 'Driver updated',
  'driver.created': 'Driver created',
  'driver.removed': 'Driver removed',
  'driver.filter': 'Search for drivers...',
  'driver.modify.title': 'Edit driver',
  'driver.create.title': 'Create driver',
  'driver.delete.confirm': 'Are you sure you want to remove driver?',
  // driver form specific
  'driver.fullName': 'Driver name and surname',
  'driver.adrNo': 'ADR Nr.',
  'driver.adrDate': 'ADR date',
  'create.driver.unique.error': 'The driver already exists',
  'create.operator.unique.error': 'Operator already exists',

  // operator form generic
  'operators': 'Scada operators',
  'operators.title': 'Scada operators',
  'operator.title': 'Scada operator',
  'operator.create.tooltip': 'Create operator',
  'operator.updated': 'Scada operator updated',
  'operator.created': 'Scada operator created',
  'operator.removed': 'Scada operator removed',
  'operator.filter': 'Search for operators...',
  'operator.modify.title': 'Edit Scada operator',
  'operator.create.title': 'Create Scada operator',
  'operator.delete.confirm': 'Are you sure you want to remove Scada operator?',
  // operator form specific
  'operator.fullName': 'Scada operator name and surname',
  'operator.adrNo': 'Scada operator ADR number',
  'operator.adrDate': 'Scada operator ADR valid until',

  // company form generic
  'companies': 'Companies',
  'companies.title': 'Companies',
  'company.title': 'Company',
  'company.create.tooltip': 'Create company',
  'company.updated': 'Company updated',
  'company.created': 'Company created',
  'company.removed': 'Company removed',
  'company.filter': 'Search for companies ...',
  'company.modify.title': 'Edit company',
  'company.create.title': 'Create company',
  'company.delete.confirm': 'Are you sure you want to remove company?',
  // company form specific
  'company.name': 'Title',
  'company.address': 'Address',
  'company.vatCode': 'VAT code',
  'company.country': 'Country',
  'company.companyCode': 'Company code',
  'company.exciseWhNo': 'Excise warehouse number',
  'company.additionalInformation': 'Additional information',
  'company.companyCode.unique': 'Company code should be unique',
  'company.code.unique': 'Company code should be unique',
  'country.select': 'Country',
  'company.whClient': 'Warehouse client',
  'company.select': 'Company',
  'company.select.sender': 'Search for sender',
  'company.select.receiver': 'Search for recipient',
  'company.whClient.select': 'Warehouse client',

  // tank form generic
  'tanks': 'Tanks',
  'tanks.title': 'Tanks',
  'tank.create.tooltip': 'Create tank',
  'tank.updated': 'Tank updated',
  'tank.created': 'Tank created',
  'tank.removed': 'Tank removed',
  'tank.filter': 'Search for tanks...',
  'tank.modify.title': 'Edit tank',
  'tank.create.title': 'Create tank',
  'tank.delete.confirm': 'Are you sure you want to remove the tank?',
  // tank form specific
  'tank.name': 'Tank title',
  'tank.capacity.ltr': 'Cpacity (l)',
  'tank.capacity.kg': 'Capacity (kg)',
  'tank.material': 'Product',
  'tank.name.unique': 'Tank title should be unique',

  // transport form generic
  'transports': 'Vehicles',
  'transports.title': 'Vehicles',
  'transport.title': 'Vehicle',
  'transport.create.tooltip': 'Create vehicle',
  'transport.updated': 'Vehicle updated',
  'transport.created': 'Vehicle created',
  'transport.removed': 'Vehicle removed',
  'transport.filter': 'Search for vehicles',
  'transport.edit.title': 'Edit vehicle',
  'transport.create.title': 'Create vehicle',
  'transport.delete.confirm': 'Are you sure you want to remove the vehicle?',
  // transport form specific
  'transportType.select': 'Type',
  'transport.name.unique': 'Vehicle title should be unique.',
  'transports.description': 'Description',
  'transports.brand': 'Brand',
  'transports.model': 'Model',
  'transports.adrNo': 'ADR number',
  'transports.identificationNo': 'Number',
  'transports.adrDate': 'ADR valid until',
  'transports.segments': 'Segments',
  'transports.segmentNo': 'Segment Nr.',
  'transports.capacityLtr': 'Segment capacity, l',
  'transport.segment.add': 'Add',
  'transport.segment.remove': 'Remove',
  'transport.identificationNo': 'Number',
  'transport.type': 'Type',
  'transport.used.in.order': 'Vehicle is used in orders and cannot be removed.',

  // Lithoil order tables
  'order.report.remove.error': 'The table cannot be removed',
  'order.sender.name': 'Sender name',
  'order.sender.address': 'Sender address',
  'order.sender.vatCode': 'Sender VAT code',
  'order.sender.companyCode': 'Sender company code',
  'order.sender.exciseWhNo': 'Sender excise warehouse No.',
  'order.sender.additionalInformation': 'Sender additional information',
  'order.receiver.name': 'Receiver name',
  'order.receiver.address': 'Receiver address',
  'order.receiver.vatCode': 'Receiver VAT code',
  'order.receiver.companyCode': 'Receiver company code',
  'order.receiver.exciseWhNo': 'Receiver excise warehouse No.',
  'order.receiver.additionalInformation': 'Receiver additional information',
  'order.carrier.name': 'Carrier name',
  'order.carrier.address': 'Carrier address',
  'order.carrier.vatCode': 'Carrier VAT code',
  'order.carrier.companyCode': 'Carrier company code',
  'order.carrier.exciseWhNo': 'Carrier excise warehouse No.',
  'order.carrier.additionalInformation': 'Carrier additional information',
  'order.delivery.name': 'Delivery name',
  'order.delivery.address': 'Delivery address',
  'order.delivery.vatCode': 'Delivery VAT code',
  'order.delivery.companyCode': 'Delivery company code',
  'order.delivery.exciseWhNo': 'Delivery excise warehouse No.',
  'order.delivery.additionalInformation': 'Delivery additional information',
  'order.seller.name': 'Seller name',
  'order.seller.address': 'Seller address',
  'order.seller.vatCode': 'Seller VAT code',
  'order.seller.companyCode': 'Seller company code',
  'order.seller.exciseWhNo': 'Seller excise warehouse No.',
  'order.seller.additionalInformation': 'Seller additional information',
  'order.buyer.name': 'Buyer name',
  'order.buyer.address': 'Buyer address',
  'order.buyer.vatCode': 'Buyer VAT code',
  'order.buyer.companyCode': 'Buyer company code',
  'order.buyer.exciseWhNo': 'Buyer excise warehouse No.',
  'order.buyer.additionalInformation': 'Buyer additional information',
  'order.vehicle.identificationNo': 'Vehicle No.',
  'order.vehicle.adrNo': 'Vehicle ADR No',
  'order.vehicle.adrDate': 'Vehicle ADR date',
  'order.trailer.identificationNo': 'Trailer No.',
  'order.trailer.adrNo': 'Trailer ADR No.',
  'order.trailer.adrDate': 'Trailer ADR date',
  'order.cmrNo': 'CMR No.',
  'order.cmrSerialNo': 'CMR Serial No.',
  'order.eAd': 'eAD',
  'order.exciseTariff': 'Excise tariff',
  'order.unloadDate': 'Unload date',
  'order.orderProducts.material.type': 'Product',
  'order.orderProducts.material.classificator': 'Product classificator',
  'order.orderProducts.material.tarrifGroupCode': 'Product tarrif group code',
  'order.orderProducts.orderProductComponents.value': 'Component value',
  'order.orderProducts.orderProductComponents.value.material': 'Component',
  'order.transaction.eventDateTime': 'Date, time',
  'order.transaction.meterId': 'Gas station',
  'order.transaction.temperature': 'Temperature',
  'order.transaction.density': 'Density',
  'order.transaction.density15': 'Density 15C',
  'order.transaction.fuelQuantityKg': 'Weight kg',
  'order.transaction.fuelQuantityLtr': 'Liters',
  'order.transaction.fuelQuantityLtr15C': 'Liters 15c',
  'order.transaction.compBQuantityKg': 'RRME weight kg',
  'order.transaction.compBQuantityLtr': 'RRME liters',
  'order.transaction.compBQuantityLtr15C': 'RRME liters 15c',
  'order.transaction.totalKg': 'Total weight kg',
  'order.transaction.totalLtr': 'Total liters',
  'order.transaction.totalLtr15C': 'Total liters 15c',
  'order.orderOperator.fullName': 'Operator',
  'order.orderDriver.fullName': 'Driver',
  'order.orderDriver.adrNo': 'Driver ADR No.',
  'order.orderDriver.adrDate': 'Driver ADR date',

  'unloadOrder.eventDateTime': 'Recharge date, time',
  'unloadOrder.eAd': 'eAD',
  'unloadOrder.sender.name': 'Sender name',
  'unloadOrder.sender.address': 'Sender address',
  'unloadOrder.sender.vatCode': 'Sender VAT code',
  'unloadOrder.sender.companyCode': 'Sender company code',
  'unloadOrder.sender.exciseWhNo': 'Sender excise warehouse No.',
  'unloadOrder.receiver.name': 'Receiver Pavadinimas',
  'unloadOrder.receiver.address': 'Receiver address',
  'unloadOrder.receiver.vatCode': 'Receiver VAT code',
  'unloadOrder.receiver.companyCode': 'Receiver company code',
  'unloadOrder.receiver.additionalInfo': 'Receiver additional information',
  'unloadOrder.product': 'Product',
  'unloadOrder.cmr': 'CMR',
  'unloadOrder.weight': 'Weight kg',
  'unloadOrder.volume': 'Liters',
  'unloadOrder.volume15C': 'Liters 15C',
  'unloadOrder.density15C': 'Destiny 15C',
  'unloadOrder.temperature': 'Temperature',
  'unloadOrder.wagon.weight': 'Wagon weight kg',
  'unloadOrder.wagon.volume': 'Wagon liters',
  'unloadOrder.wagon.volume15C': 'Wagon liters 15C',
  'unloadOrder.wagon.density15C': 'Wagon destiny 15C',
  'unloadOrder.wagon.smgs': 'SMGS',
  'unloadOrder.wagon.tanker': 'Wagon No.',
  'unloadOrder.trailer.identificationNo': 'Trailer No.',
  'unloadOrder.vehicle.identificationNo': 'Vehicle No.',

  // order form generic
  'orders': 'Export',
  'orders.title': 'Orders',
  'order.title': 'Order',
  'order.delete.confirm': 'Are you sure you want to remove the order?',
  'order.updated': 'Order updated',
  'order.removed': 'Order removed',
  'order.created': 'Order created',
  'order.filter': 'Search for orders...',
  'order.modify.title': 'Edit order',
  'order.view.title.begin': 'Oder ',
  'order.view.title.end': 'preview',
  'order.copy.title': 'Create order',
  'order.create.title': 'Create order',
  'order.create.tooltip': 'Create order',
  // order form specific
  'order.save.failed': 'Action cannot be performed',
  'order.orderNo.unique': 'Oder number should be unique',
  'order.cmrNo.unique': 'CMR number should be unique',
  'order.type': 'Order',
  'order.find.no': 'Number',
  'order.date.from': 'Date from',
  'order.date.to': 'Date to',
  'order.date': 'Recharge date',
  'order.mainOrderNo': 'Main order No.',
  'order.orderDetailCMR.cmrSerialNo': 'CMR serial No.',
  'order.orderDetailCMR.cmrNo': 'CMR No.',
  'order.orderNo': 'Order No.',
  'order.orderInfo': 'Order information',
  'order.product': 'Product ',
  'order.products': 'Products ',
  'order.product.find': 'Search...',
  'order.eAD': 'eAD ',
  'order.exciseTarrif': 'Excise tarrif  ',
  'order.qualityCertificateNo': 'Quality certification No.  ',
  'order.qualityCertificateDate': 'Quality sertificate date',
  'order.seals': 'Seals  ',
  'order.technicalPour': 'Technical pour',
  'order.rrmeAmmountPercent': 'RRME ammount, %',
  'order.redDyeRation': 'Red paint, PPM',
  'order.greenDyeRatio': 'Green paint, PPM',
  'order.rrmeAmmountLiter': 'RRME ammount, l',
  'order.redDyeMg': 'Red paint, mg',
  'order.greenDyeMg': 'Green dye, mg',
  'order.productAmmountLtr': 'Product ammount, l',
  'order.seller.remove': 'Remove seller',
  'order.buyer.remove': 'Remove buyer',
  'order.sender.remove': 'Remove sender',
  'order.receiver.remove': 'Remove recipient',
  'order.carrier.remove': 'Remove carrier',
  'order.delivery.remove': 'remove delivery place',
  'order.sender.find': 'Search for sender...',
  'order.sender': 'Sender',
  'order.receiver.find': 'Search for recipient...',
  'order.receiver': 'Recipient',
  'order.receivers': 'Recipients',
  'order.delivery.find': 'Search...',
  'order.delivery': 'Delivery place',
  'order.carrier.find': 'Search for carrier...',
  'order.carrier': 'Carrier',
  'order.buyer.find': 'Search for seller...',
  'order.buyer': 'Buyer',
  'order.seller.find': 'Search for seller...',
  'order.seller': 'Seller',
  'order.driver.find': 'Search for driver...',
  'order.driver': 'Driver',
  'order.operator.find': 'Search for Scada operator...',
  'order.operator': 'Scada operator',
  'order.clear.driver': 'Remove driver',
  'order.clear.operator': 'Remove operator',
  'order.clear.sender': 'Remove sender',
  'order.clear.receiver': 'Remove recipient',
  'order.clear.carrier': 'Remove carrier',
  'order.clear.delivery': 'Remove delivery place',
  'order.clear.buyer': 'Remove buyer',
  'order.clear.seller': 'Remove seller',
  'order.clear.vehicle': 'Remove vehicle',
  'order.clear.trailer': 'Remove trailer',
  'order.clear.product': 'Remove product',
  'driver.adrDate.not.valid': 'Driver ADR not valid',
  'order.vehicle': 'Vehicle',
  'order.vehicle.find': 'Search...',
  'order.trailer': 'Trailer',
  'order.trailer.find': 'Search...',
  'order.island': 'Island',
  'order.invoiceNo': 'Invoice No.',
  'order.transport.segment': 'Segments',
  'order.transport.segment.quantityLtr15C': 'Ammount, l',
  'order.transport.segment.capacityLtr': 'Capacity, l',
  'order.transport.segment.segmentNo': 'Segment No.',
  'order.sum.order': 'Order',
  'order.sum.product': 'Product',
  'order.sum.vehicle': 'Vehicle',
  'order.sum.trailer': 'Trailer',
  'order.sum.full': 'Total',
  'order.sum': 'Quantity exclusion',
  'order.sum.title': 'Total: ',
  'order.transports.adrNo': 'ADR No.',
  'order.transports.adrDate': 'ADR date',
  'order.searchButton': 'Search',
  'order.change.history': 'History',
  'order.change.history.block': 'Block',
  'order.change.history.field': 'Field',
  'order.change.history.oldValue': 'Old value',
  'order.change.history.newValue': 'New value',
  'order.change.history.comment': 'Comment: ',
  'order.list.date': 'Recharge date',
  'order.list.mainOrderNo': 'Main order No.',
  'order.list.cmrNo': 'CMR number',
  'order.driver.fullName': 'Full name',
  'order.driver.adrNo': 'ADR No.',
  'order.driver.adrDate': 'ADR date',
  'order.operator.fullName': 'Full name',
  'order.remove.error.loaded': 'Cannot remove because filling is completed',
  'order.edit.comment.dialog.title': 'Comment',
  'order.edit.comment.field.label': 'Please enter the reason for change',
  'order.item.create': 'Create new',
  'order.technicalPour.finish': 'Finish technical pour.',

  'order.change.history.orderCompanies.1': 'Sender',
  'order.change.history.orderCompanies.2': 'Recipient',
  'order.change.history.orderCompanies.3': 'Carrier',
  'order.change.history.orderCompanies.4': 'Delivery place',
  'order.change.history.orderCompanies.5': 'Seller',
  'order.change.history.orderCompanies.6': 'Buyer',
  'order.change.history.orderDrivers': 'Driver',
  'order.change.history.orderTransports.1': 'Vehicle',
  'order.change.history.orderTransports.2': 'Trailer',
  'order.change.history.orderTransports.4': 'Semitrailer',
  'order.change.history.orderDetails': 'Trailer segments',
  'order.change.history.orderDetails.quantityLtr15C': 'Ammount',
  'order.change.history.orderDetails.orderProductId': 'Product',
  'order.change.history.orderDetails.orderTransportSegmentId': 'Segment No.',
  'order.change.history.orderProducts': 'Product',
  'order.change.history.orderProducts.productId': 'Product',
  'order.change.history.orderProducts.qtyLtr': 'Amount',
  'order.change.history.orders': 'Order info',
  'order.change.history.orderCompanies': 'Company',
  'order.change.history.orderCompanies.name': 'Title',
  'order.change.history.orderCompanies.address': 'Address',
  'order.change.history.orderCompanies.vatCode': 'VAT code',
  'order.change.history.orderCompanies.companyCode': 'Company code',
  'order.change.history.orderTransports.identificationNo': 'Number',
  'order.change.history.orderTransports.brand': 'Brand',
  'order.change.history.orderTransports.adrDate': 'ADR date',
  'order.change.history.orderTransports.adrNo': 'ADR No.',
  'order.change.history.orderTransportSegments': 'Segment capacity',
  'order.change.history.orderTransportSegments.segmentNo': 'Segment No.',
  'order.change.history.orderTransportSegments.capacityLtr': 'Capacity, l',
  'order.change.history.orderTransportSegments.capacityKg': 'Capacity, kg',
  'order.change.history.orderTransportSegments.orderTransportId': 'Segment Id',
  'order.change.history.orderDrivers.fullName': 'Full name',
  'order.change.history.orderDrivers.adrNo': 'ADR number',
  'order.change.history.orderDrivers.adrDate': 'ADR valid until',
  'order.change.history.orders.orderNo': 'Order number',
  'order.change.history.orders.mainOrderNo': 'Main order No.',
  'order.change.history.orders.cmrNo': 'CMR number',
  'order.change.history.orders.cmrSerialNo': 'Serial No.',
  'order.change.history.orders.eAd': 'eAD',
  'order.change.history.orders.seals': 'Seals',
  'order.change.history.orders.exciseTariff': 'Excise tariff',
  'order.change.history.orders.qualityCertificateNo': 'Quality certificate No.',
  'order.change.history.orders.qualityCertificateDate':
    'Quality sertificate date',
  'order.change.history.orders.unloadDate': 'Recharge date',
  'order.change.history.orders.islandNo': 'Island',
  'order.change.history.orders.invoiceNo': 'Invoice No.',
  'order.change.history.orders.technicalPour': 'Technical pour',
  'order.change.history.orderProductComponents': 'Product components',
  'order.change.history.orderProductComponents.value': 'Value',
  'order.change.history.orderProductComponents.orderProductId': 'Product',
  'order.change.history.orderProductComponents.componentId': 'Component',
  'order.receipt.title': 'Receipt',
  'order.receipt.print': 'Print receipt',
  'order.receipt.island': 'Island No.',
  'order.receipt.orderNo': 'Order No.',
  'order.receipt.cmrNo': 'CMR',
  'order.receipt.transport': 'Vehicle / trailer',
  'order.receipt.temperature': 'Temperature',
  'order.receipt.density': 'Density',
  'order.receipt.density15C': 'Density +15C',
  'order.receipt.weight': 'Kilograms',
  'order.receipt.volume': 'Liters',
  'order.receipt.volume15C': 'Liters +15C',
  'order.receipt.diesel': 'Diesel',
  'order.receipt.rrme': 'RRME',
  'order.receipt.rrme%': 'Bio %',
  'order.receipt.total': 'Total',
  'order.receipt.seals': 'Seals',
  'order.receipt.snd': 'SND',
  'order.edit.tooltip': 'Edit order',
  'order.cmrRrme.print': 'Print bill of landing',
  'order.cmrRrme.print.noData': 'Lack of information to create document',
  'order.cmr.print': 'Print oder CMR',
  'order.transactions.eAd': 'eAD',
  'order.transactions.weight': 'Kilograms',
  'order.transactions.volume': 'Liters',
  'order.transactions.volume15C': 'Liters 15C',

  'vehicle.adrDate.not.valid': 'Vehicle ADR not valid',
  'trailer.adrDate.not.valid': 'Trailer ADR not valid',

  "clients":'Clients',
  "clients.title":"Clients",
  "client.dataLakeId":"Datalake ID",
  "client.isDataLake":"Client is Datalake",
  "client.namespace":"Client namespace",
  "client.name":"Client name",
  "client.languages":"Client languages",
  "client.addons":"Client addons",
  "client.modify.title":"Edit client",
  'client.create.title': 'Create client',
  "client.title":"Client",
  'client.created': 'Client created',
  'client.updated': 'Client updated',
  'client.removed': 'Client removed',
  'client.remove.error':
    'Client cannot be removed because of relations with other data.',
  'client.delete.confirm': 'Are you sure you want to remove client?',
  'client.filter':"Search for client...",

  'users': 'Users',
  'user.filter': 'Search for users...',
  'users.title': 'Users',
  'user.title': 'User',
  'user.profile': 'Profile',
  'user.modify.title': 'Edit user',
  'user.create.title': 'Create user',
  'users.create.tooltip': 'Create user',
  'user.created': 'User created',
  'user.updated': 'User updated',
  'user.removed': 'User removed',
  'user.remove.error':
    'user cannot be removed because of relations with other data.',
  'user.name': 'Name',
  'user.surname': 'Surname',
  'user.role': 'Role',
  'user.role.ADMIN': 'Administrator',
  'user.role.USER': 'User',
  'user.role.OPERATOR': 'Operator',
  'user.role.undefined': 'Undefined',
  'user.email': 'Email',
  'user.email.unique': 'Email should be unique',
  'user.username': 'Username',
  'user.username.unique': 'Username should be unique',
  'user.password': 'Password',
  'user.notify': 'Send notifications',
  'user.delete.confirm': 'Are you sure you want to remove user?',
  'user.language.select': 'Language',
  'user.language.EN': 'English',
  'user.language.ES': 'Ispano',
  'user.language.PL': 'Polskie',
  'user.language.RU': 'Русский',
  'user.language.LT': 'Lietuvių',
  'user.language.LV': 'Latviešu',
  'user.language.EE': 'Eesti',
  'user.view.edit': 'Edit user',
  'user.role.select': 'Role',
  'user.view.change.password': 'Change password',
  'user.password.change.title': 'change password',
  'user.password.old': 'Old password',
  'user.password.new1': 'New password',
  'user.password.new2': 'Repeat new password',
  'user.password.change.mismatch': 'Not matching passwords',
  'user.password.changed': 'Password changed.',
  'user.password.change.failed': 'Password was not changed. Password is incorrect.',
  'user.haveNoRights': 'Page not found',
  'user.objects': 'Objects',
  'user.object': 'Object',
  "user.access":"User access",
  'user.permissions':'Analytic dashboards',
  "user.isDataLake":"User is Datalake",

  'userObject.delete.confirm': 'Are you sure you want to remove object?',
  'userObject.created': 'Object assigned',
  'userObject.removed': 'Object removed',
  'dashboard': 'Graphic',
  'dashboard.generate': 'Generate',
  'dashboard.saveAsImage': 'Image',
  'dashboard.exportToExcel': 'Excel',
  'dashboard.dataZoom': 'Zoom in',
  'dashboard.dataZoomReset': 'Reset',
  'dashboard.restore': 'Reset',
  'dashboard.noData': 'No data found',
  'dashboard.data.title': 'Graphic',
  'dashboard.data.dateFrom': 'Date from',
  'dashboard.data.dateTo': 'Date to',
  'dashboard.data.unit': 'Unit',
  'dashboard.data.unit.WEIGHT': 'Weight, t',
  'dashboard.data.unit.VOLUME': 'Volume, m3',
  'dashboard.data.unit.VOLUME_AT_15C': 'Volume at 15°C, m3',
  'dashboard.data.unit.WEIGHT.short': 't',
  'dashboard.data.unit.VOLUME.short': 'm3',
  'dashboard.data.unit.VOLUME_AT_15C.short': 'm3',
  'dashboard.data.exportToExcel': 'Excel',
  'dashboard.data.reportdate': 'Time',
  'dashboard.data.official': 'Accounting',
  'dashboard.data.fact': 'Facts',
  'dashboard.data.factFrom': 'Fact from',
  'dashboard.data.factTo': 'Error margin',
  'dashboard.data.factPart1': 'Tank1',
  'dashboard.data.factPart2': 'Tank2',
  'dashboard.data.factPart3': 'Tank3',
  'dashboard.data.factPart4': 'Tank4',
  'dashboard.data.factPart5': 'Tank5',
  'dashboard.data.factPart6': 'Tank6',
  'dashboard.data.factPart7': 'Tank7',
  'dashboard.data.factPart8': 'Tank8',
  'dashboard.data.diff': 'Difference',
  'dashboard.data.counter': 'Counter',
  'dashboard.data.counterDiff': 'Counter difference',
  'administration': 'Administration',
  'reports': 'Reports',
  'journals': 'Journals',
  'reports.generate': 'Generate',
  'reports.export': 'Export',
  'reports.export.PDF': 'Export PDF',
  'reports.export.XLS': 'Export XLS',
  'reports.type': 'Select..',
  'reports.type.warehouseProducts': 'Warehouse journals',
  'reports.type.clientProducts': 'Client journals',
  'reports.type.excisableGoods': 'Excise goods',
  'reports.type.crm': 'CMR',
  'reports.type.crmRrme': 'Freight shipping waybill',
  'reports.type.cmrReconciliationAct': 'CMR act',
  'reports.type.invoiceRegistrationLog': 'Journal of Bills of landing',
  'reports.type.receiptsReports': 'Import reports',
  'reports.type.arrivalWagons': 'Arriving wagons',
  'reports.type.densityConversionLog': 'Journal of Density change',
  'reports.filter.page': 'Page No.',
  'reports.filter.orderNo': 'Order No.',
  'reports.filter.dateFrom': 'Date from',
  'reports.filter.dateTo': 'Date to',
  'reports.filter.product': 'Product',
  'reports.filter.client': 'Client',
  'reports.filter.type': 'Type',
  'reports.filter.sender': 'Sender',
  'reports.filter.receiver': 'Receiver',
  'reports.filter.mainOrderNo': 'Main order No.',
  'reports.filter.cmrNo': 'CMR number',
  'reports.filter.cmrRmeNo': 'Bill of landing No.',
  'reports.type.excisableGoods.reportTitle': 'Excise goods',
  'reports.type.excisableGoods.reportFullTitle':
    'JOURNAL OF EXCISE GOODS WAREHOUSE',
  'reports.type.excisableGoods.rowNo': 'No.',
  'reports.type.excisableGoods.date': 'Date',
  'reports.type.excisableGoods.time': 'Time',
  'reports.type.excisableGoods.kpn': 'KPN code',
  'reports.type.excisableGoods.groupCode': 'Tariff group code',
  'reports.type.excisableGoods.title': 'Product title',
  'reports.type.excisableGoods.uom': 'Units (ltr)',
  'reports.type.excisableGoods.income': 'Incomes',
  'reports.type.excisableGoods.operationCode': 'Operation code',
  'reports.type.excisableGoods.documentNo': 'Document series and number',
  'reports.type.excisableGoods.qty': 'Quantity at 15°C',
  'reports.type.excisableGoods.expenses': 'Expenses',
  'reports.type.excisableGoods.operationCode2': 'Operatoin code',
  'reports.type.excisableGoods.documentNo2': 'Document series and number',
  'reports.type.excisableGoods.qty2': 'Quantity at 15°C',
  'reports.type.excisableGoods.balanceAfter': 'Balance after',
  'reports.type.excisableGoods.leftQty': 'operations',
  'reports.type.excisableGoods.metersBeforeOper': 'Counter before',
  'reports.type.excisableGoods.meters': 'Counter after',
  'reports.type.excisableGoods.responsiblePerson': 'Responsible',
  'reports.type.excisableGoods.person': 'name, surname, signature',
  'reports.type.excisableGoods.responsiblePersonSignature': 'Responsible',
  'reports.metersDataAfterOperations': 'COUNTER DATA AFTER OPERATIONS',
  'reports.total': 'Totala',
  'reports.type.invoiceRegistrationLog.reportTitle': 'Freight shipping waybill',
  'reports.type.invoiceRegistrationLog.reportFullTitle':
    'FREIGHT SHIPPING WAYBILL',
  'reports.type.invoiceRegistrationLog.rowNo': 'No.',
  'reports.type.invoiceRegistrationLog.invoice': 'Bill of landing',
  'reports.type.invoiceRegistrationLog.eventDateTime': 'Date',
  'reports.type.invoiceRegistrationLog.orderNo': 'No.',
  'reports.type.invoiceRegistrationLog.companyInfo':
    'Recipient title and address',
  'reports.type.invoiceRegistrationLog.cargo': 'Cargo',
  'reports.type.invoiceRegistrationLog.product': 'Title',
  'reports.type.invoiceRegistrationLog.pvLtr': 'Quantity fact',
  'reports.type.invoiceRegistrationLog.pvLtr15c': 'Quantity +15C',
  'reports.type.invoiceRegistrationLog.pvKg': 'Quantity kg',
  'reports.type.invoiceRegistrationLog.reportGeneratedAt': 'Generated at',
  'reports.type.receiptsReports.reportTitle': 'Receipt report',
  'reports.type.receiptsReports.reportFullTitle': 'RECEIPT REPORT',
  'reports.type.receiptsReports.date': 'Date',
  'reports.type.receiptsReports.time': 'Time',
  'reports.type.receiptsReports.operationCode': 'Operation code',
  'reports.type.receiptsReports.fromPerson': 'Buyer / seller',
  'reports.type.receiptsReports.title': 'title (full name)',
  'reports.type.receiptsReports.identificationNo':
    'permit or identification number (code)',
  'reports.type.receiptsReports.qty': 'Quantity/mass',
  'reports.type.receiptsReports.qtyL': 'liters under the actual temperature',
  'reports.type.receiptsReports.qtyTemp': 'liters + 15° C temperature',
  'reports.type.receiptsReports.qtyKg': 'kilograms',
  'reports.type.receiptsReports.documentNo': 'Document type, serial, number',
  'reports.type.receiptsReports.ownerTitle': 'Product owner title and code',
  'reports.type.conversionLog.reportTitle': 'Journal of Density change',
  'reports.type.conversionLog.reportFullTitle': 'JOURNAL OF DENSITY CHANGE',
  'reports.type.conversionLog.date': 'Date',
  'reports.type.conversionLog.capacity': 'Tank No.',
  'reports.type.conversionLog.oldDencity': 'Old density at 15C',
  'reports.type.conversionLog.newDencity': 'New density at 15C',
  'reports.type.conversionLog.change': 'Change',
  'reports.type.conversionLog.operator': 'Operators',
  'reports.type.arrivalWagons.reportTitle': 'Arrived wagons',
  'reports.type.arrivalWagons.reportFullTitle': 'ARRIVED WAGONS',
  'reports.type.arrivalWagons.arrived': 'Arrived',
  'reports.type.arrivalWagons.date': 'Date',
  'reports.type.arrivalWagons.seller': 'Seller',
  'reports.type.arrivalWagons.receiver': 'Recipient-(LG-invoice)',
  'reports.type.arrivalWagons.buyer': 'Buyer',
  'reports.type.arrivalWagons.smgs': 'SMGS-No.',
  'reports.type.arrivalWagons.wagonNo': 'Wagon-No',
  'reports.type.arrivalWagons.document': 'Document',
  'reports.type.arrivalWagons.documentDate': 'Date',
  'reports.type.arrivalWagons.documentNo': 'No.',
  'reports.type.arrivalWagons.qtyKg': 'Quantity-KG',
  'reports.type.arrivalWagons.qtyL': 'Quantity-LTR',
  'reports.type.arrivalWagons.earned': 'Earned',
  'reports.type.arrivalWagons.postingKg': 'kg',
  'reports.type.arrivalWagons.receivedKg': 'kg',
  'reports.type.arrivalWagons.factReceived': 'Fact received',
  'reports.type.products.reportTitle': 'Product report',
  'reports.type.products.reportFullTitle': 'PRODUCT REPORT',
  'reports.type.products.rowNo': 'No.',
  'reports.type.products.date': 'Date',
  'reports.type.products.time': 'Time',
  'reports.type.products.kpn': 'KPN code',
  'reports.type.products.groupCode': 'Tariff group code',
  'reports.type.products.title': 'Product title',
  'reports.type.products.operationCode': 'Operation code',
  'reports.type.products.fromPerson': 'Buyer / seller',
  'reports.type.products.toPerson': 'Received from / recharged to',
  'reports.type.products.companyTitle': 'title (full name)',
  'reports.type.products.companyIdentificationNo':
    'permit or identification number (code)',
  'reports.type.products.qty': 'Quantity/mass',
  'reports.type.products.qtyL': 'liters under the actual temperature',
  'reports.type.products.qtyTemp': 'liters + 15° C temperature',
  'reports.type.products.qtyKg': 'kilograms',
  'reports.type.products.documentNo': 'Document type, serial, number',
  'reports.type.products.afterOperation': 'Balance after',
  'reports.type.products.responsiblePerson': 'Responsible',
  'reports.type.products.person': 'full name',
  'reports.chooseProduct': 'Product',
  'reports.dateFrom': 'From',
  'reports.dateTo': 'To',
  'reports.noData': 'No data available..',
  'analytics.title': 'Summaries',
  'analytics.material-traffic.title': 'Fuel movement',
  'analytics.warehouse-traffic.title': 'Warehouse movement',
  'countersCorrections.title': 'Alignments',
  'countersCorrection.title': 'Alignment',
  'countersCorrection.edit_title': 'Alignment correction',
  'countersCorrection.create_title': 'Create alignment',
  'countersCorrection.delete_title': 'Remove alignment',
  'countersCorrection.created': 'Alignment created',
  'countersCorrection.calculate': 'Calculate',
  'countersCorrection.updated': 'Alignment changed',
  'countersCorrection.removed': 'Alignment removed',
  'countersCorrection.id': 'No.',
  'countersCorrection.eventDateTime': 'Date',
  'countersCorrection.eventDateTime.time': 'Time',
  'countersCorrection.weight': 'Kilograms',
  'countersCorrection.volume': 'Liters',
  'countersCorrection.volume15c': 'Liters 15C',
  'countersCorrection.weightDiff': 'Kilograms',
  'countersCorrection.volumeDiff': 'Liters',
  'countersCorrection.volume15cDiff': 'Liters 15C',
  'countersCorrection.confirmDelete':
    'Are you sure you want to remove the alignment?',
  'internalOrders.title': 'Internal orders',
  'internalOrder.title': 'Internal order',
  'internalOrder.create_title': 'Create internal order',
  'internalOrder.delete_title': 'Remove internal order',
  'internalOrder.created': 'Internal order created',
  'internalOrder.updated': 'Internal order changed',
  'internalOrder.removed': 'Internal order removed',
  'internalOrder.filter': 'Search for internal order...',
  'internalOrder.id': 'No.',
  'internalOrder.orderNo': 'eAD',
  'internalOrder.orderDateTime': 'Order date',
  'internalOrder.orderDateTime.time': 'Order time',
  'internalOrder.orderTypeId': 'Order type',
  'internalOrder.operationType': 'Type',
  'internalOrder.eventDateTime': 'Movement date',
  'internalOrder.material': 'Product',
  'internalOrder.eventDateTime.time': 'Movement time',
  'internalOrder.weight': 'Kilograms',
  'internalOrder.volume': 'Liters',
  'internalOrder.volume15c': 'Liters 15C',
  'internalOrder.receiver': 'Recipient',
  'internalOrder.sender': 'Sender',
  'internalOrder.confirmDelete':
    'Are you sure you want to remove the internal order?',
  'internalOrder.errorEx': 'Returning order',
  'internalOrder.errorGr': 'Outgoing order',
  'internalOrder.order': 'Corrective order',
  'operationType.select': 'Order type',
  'unloadMeterData.fact': 'Fact',
  'unloadMeterData.doc': 'Accounting',
  'unloadMeterData.diff': 'Difference',
  'unloadMeterData.weight.short': 'kg',
  'unloadMeterData.volume.short': 'l',
  'unloadMeterData.volume15C.short': 'l',
  'unloadMeterData.density15C.short': 'kg/l',
  'weight.short': 'Kg',
  'volume': 'Liters',
  'volume15C': 'Liters15',
  'density15C.short': 'Kg/l',
  'railwayOrders.title': 'Comparisons',
  'railwayOrders.tooltip': 'Fact vs accounting',
  'railwayOrder.title': 'Comparison',
  'railwayOrder.title.create.panel': 'Import',
  'railwayOrder.title.edit.panel': 'import',
  'railwayOrder.create_title': 'Create import order',
  'railwayOrder.delete_title': 'Remove import order',
  'railwayOrder.created': 'Import order created',
  'railwayOrder.updated': 'Import order changed',
  'railwayOrder.removed': 'Import order removed',
  'railwayOrder.filter.eventDateTimeFrom': 'Date from',
  'railwayOrder.filter.eventDateTimeTo': 'Date to',
  'railwayOrder.filter.material': 'Product',
  'railwayOrder.filter.eAd': 'eAD',
  'railwayOrder.filter.summary': 'Total',
  'railwayOrder.id': 'No.',
  'railwayOrder.eAd': 'eAD',
  'railwayOrder.eventDateTime': 'Recharge date',
  'railwayOrder.eventDateTime.time': 'recharge time',
  'railwayOrder.weight': 'Kilograms',
  'railwayOrder.volume': 'Liters',
  'railwayOrder.volume15C': 'Liters 15C',
  'railwayOrder.density15C': 'Density 15C',
  'railwayOrder.temperature': 'Temperature',
  'railwayOrder.receiver': 'RECIPIENT',
  'railwayOrder.receiverName': 'Recipient',
  'railwayOrder.sender': 'SENDER',
  'railwayOrder.senderName': 'Sender',
  'railwayOrder.order': 'ORDER INFORMATION',
  'railwayOrder.wagon': 'WAGONS',
  'railwayOrder.summary': 'DIFFERENCE',
  'railwayOrder.confirmDelete':
    'Are you sure you want to remove the import order?',
  'railwayOrders.refresh': 'Update recharges',
  'railwayOrderDetail.tankerId': 'Wagon No.',
  'railwayOrderDetail.smgs': 'SMGS',
  'railwayOrderDetail.weight': 'Kilograms',
  'railwayOrderDetail.volume': 'Liters',
  'railwayOrderDetail.volume15C': 'Liters 15C',
  'railwayOrderDetail.density15C': 'Density 15C',
  'railwayOrderDetail.remove': 'Remove wagon',
  'railwayOrderDetail.add': 'Add wagon',
  'button.save.tooltip': 'Save',
  'button.cancel.tooltip': 'Cancel',
  'button.edit.tooltip': 'Edit',
  'incomeOrders.title': 'Income',
  'incomeOrders.filter.ead': 'eAD No...',
  'incomeOrder.eAD': 'eAD',
  'incomeOrder.eventDateTime': 'Date',
  'incomeOrder.sender': 'Sender',
  'incomeOrder.confirmDelete': 'Are you sure you want to remove income?',
  'incomeOrders.create.trailerUnloadOrder.title': 'Income from vehicle',
  'incomeOrders.create.railwayOrder.title': 'Income from wagon',
  'incomeOrders.trailerUnloadOrder.removed': 'Income removed',
  'incomeOrders.railwayOrder.removed': 'Income removed',
  'trailerUnloadOrder.title': 'Income',
  'trailerUnloadOrder.delete_title': 'Remove income',
  'trailerUnloadOrder.created': 'Income created',
  'trailerUnloadOrder.updated': 'Income changed',
  'trailerUnloadOrder.removed': 'Income removed',
  'trailerUnloadOrder.id': 'No.',
  'trailerUnloadOrder.eAD': 'eAD',
  'trailerUnloadOrder.cmr': 'CMR',
  'trailerUnloadOrder.eventDateTime': 'Date',
  'trailerUnloadOrder.eventDateTime.time': 'Time',
  'trailerUnloadOrder.weight': 'Kilograms',
  'trailerUnloadOrder.volume': 'Liters',
  'trailerUnloadOrder.volume15c': 'Liters 15C',
  'trailerUnloadOrder.density15C': 'Density 15C',
  'trailerUnloadOrder.temperature': 'Temperature',
  'trailerUnloadOrder.receiver': 'Recipient',
  'trailerUnloadOrder.sender': 'Sender',
  'trailerUnloadOrder.vehicle': 'Vehicle',
  'trailerUnloadOrder.trailer': 'Trailer',

  'tableReport.filter.object': 'Object',
  'tableReport.filter.report': 'Report',
  'tableReport.filter.dateFrom': 'Date from',
  'tableReport.filter.dateTo': 'Date to',
  'tableReport.filter.timeSpan': 'Accuracy',
  'tableReport.object': 'Object',
  'tableReport.equipment': 'Device',
  'tableReport.parameter': 'Parameter',
  'tableReport.date.unit': 'Date / unit',
  'tableReport.aggregationType': 'Aggregation type',

  'timeSpan.select': 'Accuracy',
  'time.span.pretimespan': ' ',
  'time.span.MINUTE': 'Minute',
  'time.span.minutes': 'min ago',
  'time.span.HOUR': 'Hour',
  'time.span.hours': 'h ago',
  'time.span.DAY': 'Day',
  'time.span.days': 'd ago',
  'timeInterval.select': 'Time interval',
  'time.interval.THIS_MONTH': 'Current month',
  'time.interval.LAST_MONTH': 'Last month',
  'time.interval.LAST_WEEK': 'Last week',
  'time.interval.SELECTED_DATES': 'Period',
  'time.interval.THIS_DAY': 'Current day',
  'time.interval.LAST_DAY': 'Last day',
  'time.interval.SELECTED_DAY': 'Select day',
  'time.interval.DAY': 'Day',
  'time.interval.WEEK': 'Week',
  'time.interval.YEAR': 'This year',
  'time.interval.ALL_RECORDS': 'All records',
  'time.period.select': 'Time period',
  'time.tooFar.1h': 'Only one hour later time can be entered',

  'objectReport.select': 'report',
  'displayType.select': 'Display type',

  // FACTORY
  'factory.events': 'Parameters',

  // DANPOWER
  'danpower.events': 'Parameters',
  'danpower.events.title': 'Parameters',
  'danpower.event.site': 'Location',
  'danpower.event.object': 'Device',
  'danpower.event.eventDateTime': 'Time',
  'danpower.events.filter.site': 'Location',
  'danpower.events.filter.object': 'Device',
  'danpower.events.filter.parameter': 'Parameter',
  'danpower.events.filter.search': 'Search',

  'schemas.title': 'Schemas',
  'schemas.inidcator.status.neutral': 'Neutral',
  'schemas.inidcator.status.danger': 'Danger',
  'schema.modify.title': 'Edit',
  'schema.create.title': 'Create schema',
  'schema.name': 'Title',
  'schema.image': 'Schema image',
  'schema.indicators.select': 'Parameters',
  'schema.object': 'Object',
  'schema.indicator.search': 'Parameter',
  'schema.indicator.add': 'Add',
  'schema.added.indicators': 'Schema',
  'schema.indicators.validation.error': 'No parameters added',
  'schema.created': 'Schema created',
  'schema.updated': 'Schema updated',
  'schema.removed': 'Schema removed',
  'schema.edit': 'Edit',
  'schema.delete': 'Remove',
  'schema.create': 'Create schema',
  'schema.upsert.error': 'Schema could not be saved',
  'schema.remove.confirm': 'Are you sure you want to remove schema?',
  'schema.remove.error':
    'Schema cannot be removed because of relations with other data ' +
    ' (etc Dashboard).',
  'schema.indicator.popover.minLimit': 'Min.: {minLimit}{abbreviation}',
  'schema.indicator.popover.maxLimit': 'Max.: {maxLimit}{abbreviation}',

  'dropzone.add.file.here': 'Drop file here or click to select file',

  'warehouses.title': 'Warehouses',
  'warehouse.code': 'Code',
  'warehouse.create.title': 'Create warehouse',
  'warehouse.modify.title': 'Edit warehouse',
  'warehouse.name': 'Title',
  'warehouse.object': 'Object',
  'warehouse.title': 'Warehouses',
  'warehouse.create.tooltip': 'Create warehouse',
  'warehouse.updated': 'Warehouse updated',
  'warehouse.created': 'Warehouse created',
  'warehouse.removed': 'Warehouse removed',
  'warehouse.delete.confirm': 'Are you sure you want to remove warehouse?',
  'warehouse.upsert.error': 'Warehouse could not be saved',

  'warehouseGoods.title': 'Warehouse goods',
  'warehouseGood.create.title': 'Create warehouse good',
  'warehouseGood.modify.title': 'Edit warehouse good',
  'warehouseGood.name': 'Title',
  'warehouseGood.code': 'Code',
  'warehouseGood.price': 'Unit price',
  'warehouseGood.budgetCode': 'Budget code',
  'warehouseGood.document': 'Purchase document',
  'warehouseGood.title': 'Warehouse good',
  'warehouseGood.unit': 'Measurement',
  'warehouseGood.initialAmount': 'Initial amount',
  'warehouseGood.create.tooltip': 'Create warehouse good',
  'warehouseGood.updated': 'Warehouse good updated',
  'warehouseGood.created': 'Warehouse good created',
  'warehouseGood.removed': 'Warehouse good removed',
  'warehouseGood.upsert.error': 'Warehouse good could not be saved',
  'warehouseGood.remove.error':
    'Warehouse good cannot be removed because of relations with other data.',
  'warehouseGood.delete.confirm':
    'Are your sure you want to remove warehouse good?',
  'warehouseGood.export.includeZeroStartingAmount': 'Include with zero staring amount',

  'warehouseGoods.filter.name': 'Title',
  'warehouseGoods.filter.code': 'Code',
  'warehouseGoods.filter.balanceStatus': 'Balance in warehouse',
  'warehouseGood.balanceStatus.all': 'All',
  'warehouseGood.balanceStatus.full': 'Full amount',
  'warehouseGood.balanceStatus.empty': 'Empty amount',
  'warehouseGood.balanceStatus.missing': 'Missing amount',

  'warehouseGoodAction.amount.overBalance': 'Please specify value lower than balance',
  'warehouseGoodAction.upsert.error': 'Balance could not be saved',
  'warehouseGoodsItem.code': 'Code: {code}',
  'warehouseGoodsItem.oldCode': 'Old code: {code}',
  'warehouseGoodsItem.initialAmount': 'Initial amount: {initialAmount} {unit}',
  'warehouseGoodsItem.balance': 'Balance: {balance} {unit}',
  'warehouseGoodReplenish.initialAmount': 'Replenish',
  'warehouseGoodReplenish.date': 'Date',
  'not.found.page.header': 'Entity not found',
  'not.found.page.message': 'Sorry, entity not found or you don\'t have permissions to access it.',
  'not.found.page.go.back': 'Go back',

  'fixedAsset.title': 'Fixed asset',
  'fixedAsset.code': 'R code',

  'repairs.title': 'Repairs',
  'yearly.repairs.title': 'Yearly Repairs',
  'repair.code': 'Code',
  'repair.create.title': 'Create repair',
  'repair.modify.title': 'Edit repair',
  'repair.name': 'Title',
  'repair.object': 'Object',
  'repair.title': 'Repairs',
  'repair.create.tooltip': 'Create repair',
  'repair.updated': 'Repair updated',
  'repair.created': 'Repair created',
  'repair.removed': 'Repair removed',
  'repair.delete.confirm': 'Are you sure you want to remove repair?',
  'repair.upsert.error': 'Repair could not be saved',
  'repair.plannedDateOfWork.time': 'Time',
  'repair.plannedDateOfWork.date': 'Date',
  
  'repair.group': 'Device Group', 
  'repair.equipment': 'Device', 
  'repair.description': 'Description', 
  'repair.plannedDate': 'Planned Date',
  'repair.finishedDate': 'Finished Date',
  'repair.doneDate': 'Finished Date', 
  'repair.worker': 'Done by workers', 
  'repair.workPrice': 'Work, €', 
  'repair.materialPrice': 'Materials, €', 
  'repair.totalCost': 'Sum, €',
  'repair.offer': 'Offer',

  "repair.import.error.missingFields": "Row {row}: Missing required fields.",
  "repair.import.error.unknownArea": "Row {row}: Unknown area {areaName}.",
  "repair.import.error.unknownEquipment": "Row {row}: Unknown equipment {equipmentName} or doesn't belong in this journal.",
  "repair.import.error.equipmentAreaMismatch": "Row {row}: Equipment {equipmentName} does not belong to Area {areaName}.",
  "repair.import.error.equipmentJournalMismatch": "Row {row}: Equipment {equipmentName} does not belong to the same object as the journal.",
  "repair.import.error.invalidDateFormat": "Row {row}: Invalid date format {dateValue}.",
  "repair.import.error.invalidDate": "Row {row}: Invalid date {dateValue}.",
  "repair.import.error.failedToCreateIssue": "Row {row}: Failed to create issue. Error: {error}",
  "repair.import.error.failedToImport": "Failed to import issues. Error: {error}",
  "repair.import.error.journal.notFound": "Journal not found",
  "repair.import.success.message": "Successfully imported {count} issues.",

  "repair.export.warning.selectYear": "Please select a year before exporting",

  "annualRepair.removed": "Annual maintenance removed",
  "select.year": "Select year",
  "Year": "Year",

  'repairObjects.unplannedExpense': 'Unplanned Expenses',
  'repairObjects.unplannedCost': 'Unplanned work',
  'repairObjects.plannedRepairsSum': 'Planned repairs',
  'repairObjects.unplannedExpenseTotal': 'Unplanned expenses total',
  'repairObjects.unplannedCostTotal': 'Unplanned work total',
  'repairObjects.plannedRepairsSumTotal': 'Planned repairs total',
  'repairObjects.grandTotal': 'Grand total',
  'repairObjects.values.saved': 'Values saved',
  'repairObjects.save': 'Save',
  'common.actions': 'Actions',
  'year': 'Year',

  'yes': 'Yes',
  'no': 'No',

  '[object Object]': "Object",

  'dashboard.title': 'Dashboard',
  'gadget.create.tooltip': 'Add gadget',
  'gadget.form.type': 'Choose gadget type',
  'gadget.form.type.chart': 'Real Time Chart',
  'gadget.form.type.table': 'Table',
  'gadget.form.type.schema': 'Schema',
  'gadget.form.type.graph': 'Graph',
  'gadget.form.type.status': 'Status',
  'gadget.form.item': 'Choose gadget item',
  'gadget.form.parameters': 'Choose gadget parameters',
  'gadget.form.name': 'Title',
  'gadget.delete.confirm': 'Are your sure you want to remove gadget?',
  'gadget.updated': 'Gadget updated',
  'gadget.created': 'Gadget created',
  'gadget.removed': 'Gadget removed',
  'gadget.notify': 'Notify by email',
  'gadget.notifyPeriod': 'Repeat',
  'gadget.notifyPeriod.MONTH': 'Each month',
  'gadget.notifyPeriod.WEEK': 'Eeach week',
  'gadget.notifyPeriod.DAY': 'Each day',
  'gadget.notifyDelay': 'Notify day',
  'gadget.notifyTime': 'Notify time',
  'gadget.dateFrom': 'Date from',
  'gadget.dateTo': 'Date to',
  'gadget.day': 'Day',
  'gadget.upsert.error': 'Gadget could not be saved',

  'chart.modify.title': 'Edit chart',
  'chart.create.title': 'Create chart',
  'chart.name': 'Chart title',
  'chart.object': 'Object',
  'chart.indicators.select': 'Parameters',
  'chart.indicator.add': 'Add',
  'chart.added.indicators': 'Added parameters',
  'chart.indicator.search': 'Select parameter...',
  'chart.created': 'Chart created',
  'chart.updated': 'Chart updated',
  'chart.create.tooltip': 'Create chart',
  'chart.modify': 'Edit chart',
  'chart.upsert.error': 'Chart could not be saved',

  'chart.remove.confirm': 'Are you sure you want to remove chart?',
  'chart.removed': 'Chart removed',
  'chart.indicators.validation.error': 'No parameters added',

  'materialType.PURE': 'Pure product',
  'materialType.MIXED': 'Mixed product',
  'materialType.ADT-PIGM': 'Additive',

  'status.object': 'Object',
  'status.production': 'Production',
  'status.prices': 'Price',
  'status.income': 'Income',
  'status.averageCapacity': 'Average Capacity',
  'status.downtime': 'Downtime, h',
  'status.downtime.OPEN': 'In operation',
  'status.downtime.PARTLY': 'Stopping',
  'status.downtime.CLOSED': 'Stopped',
  'status.status': 'Status',
  'status.electricity': 'Electricity',
  'status.heat': 'Heat',
  'status.total': 'Total',

  'journal.export.excel': 'Excel',
  'journal.export.excel.error': 'Error while creating an excel file',
  'notifications.title': `Notifications`,
  'notifications.none.found': `You do not have any new notifications`,
  'user.accessPricing': 'Access pricing',
  'user.manageEvents': 'Manage Events',
  'user.manageWarehouses': 'Manage Warehouses',
  'user.manageRepairs': 'Manage Repairs',
  'user.manageRepairBudget': 'Manage Repair Budget',
  'user.issueTaskExecutor': 'Issue Task Executor',
  "user.canApproveRecommendations": "Recommendations approver",
  'prices': 'Prices',
  'prices.title': 'Prices',
  'prices.ELECTRICITY': 'Electricity',
  'prices.HEAT': 'Heat',
  'object': 'Object',
  'indicator': 'Parameter',
  'indicatorPrice.removed': 'Price Removed',
  'price.objectFilter': 'Object',
  'price.nameFilter': 'Parameter',
  'price.create.title': 'Parameter Prices',
  'price.modify.title': 'Parameter Prices',
  'indicatorPrice.type': 'Type',
  'indicatorPrice.newPrice': 'New Price',
  'indicatorPrice.date': 'Date',
  'indicatorPrice.hour': 'Hour',
  'indicatorPrice.price': 'Price',
  'indicatorPrice.prices': 'Valid prices',
  'indicatorPrice.add': 'Add',
  'indicatorPrice.indicator.unique': 'This parameter already has a price',
  'indicatorPrice.created': 'Price created',
  'indicatorPrice.updated': 'Price updated',
  'indicatorPrice.delete.confirm': 'Are your sure you want to remove price?',
  'indicatorPrice.uniqueDate': 'This time already has a price asigned to it',
  'indicatorPrice.title': 'Title',
  'graph.type.STANDART': 'Time span',
  'graph.type.REAL_TIME': 'Real time',
  'graph.type.select': 'Graph type',
  'indicator.filter.name': 'Title',
  'indicator.filter.code': 'Code',
  'export.tooltip': 'Export',
  'export.previous': 'Last export',
  'export.noPreviousExportFound': 'No previous exports found',
  'dateFrom': 'Date from',
  'dateTo': 'Date to',
  'export.warehouseGood.nr': 'No.',
  'export.warehouseGood.code': 'Code',
  'export.warehouseGood.budgetCode': 'Budget code',
  'export.warehouseGood.name': 'Title',
  'export.warehouseGood.document': 'Document',
  'export.warehouseGood.firstCreated': 'First time added',
  'export.warehouseGood.start': 'Starting data',
  'export.warehouseGood.used': 'Used',
  'export.warehouseGood.leftOver': 'Left over',
  'export.warehouseGood.amount': 'Amount',
  'export.warehouseGood.unit': 'Units',
  'export.warehouseGood.price': 'Price',
  'export.warehouseGood.sum': 'Sum',
  'export.warehouseGood.all': 'Sum:',

  'support.page.menu': 'Contact us',
  'support.page.header': 'Contact us',
  'support.page.message':
    'Waiting for questions and comments ' +
    '<a href="mailto:support@axs.eu">support@axs.eu</a> .',
  'import.prices': 'Import Prices',
  'import.prices.successfull': 'Import of prices was succesfull',
  'import.format.wrong': 'Incorrect file format',

  // Total trash mix below, need to cleanup
  'production.producedProducts': 'Production',

  'addons': 'Modules',

  'adminAddon': 'Administration module',
  'adminAddon.description': 'Access rights administration',
  'objectInfoAddon': 'ObjectInfo module',
  'objectInfoAddon.description': 'Object information',
  'lithoil': 'Lithoil module',
  'lithoil.description': 'Oil & Gas terminals',
  'flexiCore': 'FlexiCore module',
  'flexiCore.description': 'Main system module',

  'adminAddon.managePermissions': 'Manage permissions',
  'adminAddon.managePermissions.title': 'Access management',
  'adminAddon.managePermissions.added': 'Access granted',
  'adminAddon.managePermissions.removed': 'Access revoked',
  'adminAddon.search': 'Search module or user...',
  'adminAddon.searchClient': 'Search client...',
  'adminAddon.searchAddon': 'Search module...',
  'adminAddon.header': 'Flexi modules',
  'adminAddon.subheader': 'Modules are extensions of "Flexi" product, that enable new features for users.',

  'refresh': 'Refresh',
  'lack.of.privileges': 'Lack of privileges',
  'analyticsAddon': 'Analytics addon',
  'analyticsAddon.description': 'Analytics addon module',
  'shifts': 'Shifts addon',
  'shifts.description': 'Shifts addon module',
  'adminAddon.enableAll': 'Disable all',
  'adminAddon.disableAll': 'Enable all',
  'adminAddon.searchUser': 'User search...',
  'no.privileges': 'You do not have permission to content. Contact your system administrator.',
  'selected': 'Selected',

  'subclients.error': 'Configuration error [subclients.error]. Please contact system administrators.',

  'purchaseDecision.title': 'Purchase decision',
  'purchaseDecision.recomendationSaved': 'Recommendation saved',
  'purchaseDecision.failedToSave': 'Failed to save recommendation',
  'purchaseDecision.cancelRecommendation': 'Cancel recommendation',
  'purchaseDecision.canceled': 'Recommendation canceled',
  'purchaseDecision.failedToCancel': 'Failed to cancel recommendation',
  'offers': 'Offers',
  'offer.no': 'No',
  'offer.company': 'Company of offer',
  'offer.service': 'Product/service',
  'offer.price': 'Price, €',
  'offer.notes': 'Additional information',
  'offer.add': 'Add new offer',
  'offer.remove': 'Remove offer',
  'purchaseOffer.removed': "Offer deleted",
  'offer.recommendation': 'Recomendation',
  'offer.percentage': 'Percentage %',
  'offer.confirmedBudget': 'Confirmed budget',
  'offer.budgetPrice': 'Budget row',
  'purchaseOffers.updated': 'Purchase offers updated',
  'pruchaseDecision.confirmation': 'Confirmation',

  'numberMustBeMoreThanZero': "Number must be more than 0",

  'privacyPolicy.title': ' Flexi privicy policy',
  'privacyPolicy.page.title': ' Privicy policy',
  'privacyPolicy.openPdf': 'Open PDF',
  'privacyPolicy.pdfNotSupported': 'Browser can not show PDF file.',
};

export default translations;